import api from '@/services/api'
import type { CcxtMarket, AssetExchangeContractResponse } from '../types'
import type { LeverageResponse, MarketInfo, SymbolLimits } from '../eye-v2-service/types'
import type { ApiKeyType } from '../api-keys-v2-service/types'
import type { MarketType } from '@/utils/types'

export const CoreV2Service = {
  fetchMarket(exchange: string, symbol: string) {
    symbol = symbol.toUpperCase()
    return api.get<CcxtMarket>(`/v2/market/${exchange}/${symbol}`)
  },
  fetchLimits(exchange: string, marketType: MarketType, asset: string) {
    return api.get<SymbolLimits>(`/v2/limits/${exchange}/${marketType}/${asset}`)
  },
  fetchContracts(exchange: string, asset: string, marketType: string = 'swap') {
    return api.get<AssetExchangeContractResponse[]>(`/v2/contract/${exchange}/${asset}?market_type=${marketType}`)
  },
  fetchTicker(exchange: string, symbol: string) {
    symbol = symbol.toUpperCase()
    return api.get<MarketInfo>(`/v2/ticker/${exchange}/${symbol}`)
  },
  fetchLeverage(exchange: string, symbol: string) {
    symbol = symbol.toUpperCase()
    return api.get<LeverageResponse>(`/v2/leverage/${exchange}/${symbol}`)
  },
  fetchPositions(exchange: string, profileNum: number, keyType: ApiKeyType) {
    // eslint-disable-next-line
    return api.get<Record<string, any>[]>(`/v2/positions/open/${exchange}/${profileNum}/${keyType}`)
  },
  fetchAllPositions(exchange: string, keyType: ApiKeyType) {
    // eslint-disable-next-line
    return api.get<Record<number, any[]>>(`/v2/positions/open/${exchange}/${keyType}`)
  },
  fetchAllOrders(exchange: string, keyType: ApiKeyType, marketType: MarketType, asset: string) {
    // eslint-disable-next-line
    return api.get<Record<string, any>[]>(
      `/v2/orders/open/${exchange}/${keyType}/${marketType}/${asset}`,
    )
  },
  fetchOrders(
    exchange: string,
    profileNum: number,
    keyType: ApiKeyType,
    marketType: MarketType,
    asset: string,
  ) {
    // eslint-disable-next-line
    return api.get<Record<string, any>[]>(
      `/v2/orders/open/${exchange}/${profileNum}/${keyType}/${marketType}/${asset}`,
    )
  },
  fetchPoolDev(poolAddress: string, chain: string) {
    return api.get<string | null>(`/v2/pool-dev/${poolAddress}/${chain}`)
  },
}
